<template>
    <b-row>
        <div class="col-sm-9 mt-3">
            <label for="" class="form-label">Número de depósito</label>
            <input type="text" id="campo_numerico_deposito" class="form-control form-control-sm" v-model="no_deposito"
                @keydown.enter="obtener_registros">
        </div>
        <div class="col-sm-3 mt-5">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block" @click="obtener_registros"><i
                    class="fas fa-search"></i>
                Consultar</button>
        </div>

        <div class="col-sm-12 mt-3">
            <div class="marco_consultas_deposositos">

                <table class="table table-sm table-striped table-bordered" style="font-size: 12px;">
                    <thead>
                        <tr>
                            <th style="width: 15%;text-align: center;">
                                No. DTE
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Fecha
                            </th>
                            <th style="width: 45%;text-align: center;">
                                Sucursal
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Tipo de pago
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Dif. Efectivo
                            </th>
                            <th style="width: 10%;text-align: center;">
                                Dif. Tarjeta
                            </th>

                        </tr>
                    </thead>

                    <tbody>
                        <tr v-for="(item, index) in registros" :key="index">
                            <td style="text-align: center;">
                                {{ item.dte }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.fecha_movimiento }}
                            </td>
                            <td style="text-align: center;">
                                {{ getNombreSucursal(item.sucursal) }}
                            </td>
                            <td style="text-align: center;">
                                {{ item.tipo_de_pago }}
                            </td>
                            <td style="text-align: center;">
                                Q{{ item.dif_efectivo == undefined ? item.total_movimiento.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) :
                                    item.dif_efectivo.toLocaleString(undefined, {
                                        minimumFractionDigits: 2, maximumFractionDigits: 2
                                    }) }}
                            </td>
                            <td style="text-align: center; text-decoration: line-through;">
                                Q{{ item.dif_tarjeta == undefined ? 0 : item.dif_tarjeta.toLocaleString(undefined, {
                                    minimumFractionDigits: 2, maximumFractionDigits: 2
                                }) }}
                            </td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>
        <div class="col-sm-12 mt-3">
            <div class="contenedor_total_depositos">
                Gran Total Q{{ total.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                }}
            </div>
        </div>
    </b-row>
</template>

<script>
    import { mapActions, mapState } from 'vuex';
    import { minix } from '../functions/alertas';

    export default {
        name: 'Listado',
        computed: {
            ...mapState(['id_empresa_seleccionada', 'sucursales']),
            // Nueva propiedad computada para obtener el nombre de la sucursal por código
            getNombreSucursal() {
                return (codigo) => {
                    const sucursal = this.sucursales.find(s => s.codigo === codigo);
                    return sucursal ? sucursal.nombre : 'Sucursal no encontrada';
                }
            }
        },
        data() {
            return {
                no_deposito: '',
                registros: [],
                total: 0
            }
        },
        methods: {
            calcularTotal() {
                this.total = this.registros.reduce((sum, item) => {
                    // Suma base de dif_efectivo (si existe)
                    let subtotal = item.dif_efectivo || 0;

                    // Suma adicional de total_movimiento solo cuando el tipo de pago es EFECTIVO
                    if (item.tipo_de_pago === "EFECTIVO" && item.total_movimiento) {
                        subtotal += item.total_movimiento;
                    }

                    return sum + subtotal;
                }, 0);
            },
            async obtener_registros() {
                if (this.no_deposito == '') {
                    minix({ icon: 'warning', mensaje: 'Escribe un número de depósito', tiempo: 3000 })
                    document.getElementById('campo_numerico_deposito').focus();
                    return
                }

                let f = {
                    api: `movimientos-cabeceras/c/consulta-depositos?no_deposito=${this.no_deposito}&empresa=${this.id_empresa_seleccionada}`
                }

                let r = await this.obtener_data(f);

                if (r.length == 0) {
                    minix({ icon: 'warning', mensaje: 'No se encontraron registros', tiempo: 3000 })
                    return;
                }

                this.registros = r;
                this.calcularTotal(); // Llamar a la función para calcular el total
            },
            ...mapActions(['obtener_data'])
        },
    }
</script>

<style>
    .marco_consultas_deposositos {
        width: 100%;
        height: calc(100vh - 350px);
        overflow: auto;
    }
</style>